import * as moment from "moment";
import 'moment-duration-format';
import { Component, Input, OnInit } from '@angular/core';
import { VolunteerTaskPointService } from '../../volunteer/services/volunteer-task-point.service';
import { VolunteerCallPhotoViewRecord } from '../../volunteer/models/volunteer-call-photo';
import { IAlbum, Lightbox, LightboxConfig, LightboxEvent } from 'ngx-lightbox';
import { ScoutPointPhotoService } from '../../core/services';
import { firstValueFrom, zip } from 'rxjs';

@Component({
  selector: 'app-rut-call-photos',
  templateUrl: './rut-call-photos.component.html',
  styleUrls: ['./rut-call-photos.component.scss']
})
export class RutCallPhotosComponent implements OnInit {

  @Input() callLogId: number;
  @Input() photoCnt: number;

  photos: VolunteerCallPhotoViewRecord[]|null = null;
  albumPhotos: IAlbum[] = [];

  loading = false;
  errorMsg = '';

  constructor(
    public volunteerTaskPointService:VolunteerTaskPointService,
    public photoService : ScoutPointPhotoService,
    private lightbox: Lightbox,
    private lightboxEvent: LightboxEvent,
    lightboxConfig: LightboxConfig ) {
        lightboxConfig.fitImageInViewPort = true
        lightboxConfig.showRotate = true
        lightboxConfig.showZoom = true
        lightboxConfig.fadeDuration = 0.4
  }

  ngOnInit(): void {
    if ( typeof this.photoCnt == 'string' ) {
      this.photoCnt = parseInt(this.photoCnt);
    }
    //this.loadPhotos().catch(e=>this.volunteerTaskPointService.publishError(e,this,60));
  }

  //TODO - just load all images at once for now (should only be one)
  loadPhotos = async () => {
    try {
      //this.loading = true;
      this.errorMsg = '';
      this.photos = null;
      this.photos = await this.volunteerTaskPointService.findPhotosByCallLogId(this.callLogId);
      this.photoCnt = this.photos.length;
    } catch ( e ) {
      //this.volunteerTaskPointService.publishError(e,this,60);
      this.errorMsg = this.volunteerTaskPointService.extractErrorMsg(e);
      this.volunteerTaskPointService.appState.notifyError(this.errorMsg,this,2);
    } finally {
      //this.loading = false;
    }
  }

  showPhotoModal = async () => {
    try {
      this.loading = true;
      await this.loadPhotos();
      const encodedUrls = await firstValueFrom(zip(this.photos.map(p=>
        this.photoService.downloadScoutRefPhotoFile(p.photoId,'image/jpg'))));
      this.albumPhotos = this.photos.map((photo,i)=>({
        src: encodedUrls[i],
        thumb: null,
        caption: [photo.comments||photo.fileName,`${(moment.duration(photo.photoToCallIntervalSecs,'seconds') as any).format('h [hours], m [minutes], s [seconds]')} before call.`].map(text=>text).join('<br>'),
        rutCallLogRec: photo
      }));
      this.lightbox.open(this.albumPhotos,0)
    } catch ( e ) {
      this.errorMsg = this.photoService.extractErrorMsg(e);
      this.photoService.publishErrorObj(e,this.errorMsg,this,2*60);
      this.volunteerTaskPointService.appState.notifyError(this.errorMsg,this,2);
    } finally {
      this.loading = false;
    }
  }

  // async loadPhotoFileFromServer() {
  //   //'image/jpg', 'image/png', 'image/jpeg'
  //   const photo = await this.photoService.downloadScoutRefPhotoFile(this.photos[0].photoId,'image/jpg');
  //   return photo;
  // }

}
